import api from "@/api";
import deepClone from "@/utils/deep-clone";

const state = {
    calendar: {},
};

const getters = {
    get(state) {
        return deepClone(state.calendar);
    },
};

const actions = {
    create: ({ commit }) => {
        return api.post(`/api/calendar/create`).then(res => {
            const data = res?.data ?? {};

            commit("set", data.calendar);
        });
    },
};

const mutations = {
    set(state, data) {
        state.calendar = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
